import filter from "@/api/filter";

//全部
export const allColumns = [
  {
    title: "原保单号",
    slot: "policyNo",
    align: "center",
    width: 220,
  },
  {
    title: "产品名称",
    width: 250,
    key: "productName",
    align: "center",
  },
  {
    title: "投保人/手机号",
    width: 160,
    align: "center",
    render(h, params) {
      return <span>{params.row.holderName}/{params.row.holderMobile}</span>;
    }
  },
  {
    title: "原单状态",
    align: "center",
    minWidth: 100,
    render(h, params) {
      const payStatus = params.row.policyStatus;
      const result = filter.filterInsureOrderStatus(payStatus);
      return <span>{result}</span>;
    },
  },
  {
    title: "续保状态/更进状态",
    width: 160,
    key: "payAndServiceState",
    align: "center",
  },
  {
    title: "保单到期日",
    width: 110,
    align: "center",
    render(h, params) {
      const policyEndDate = params.row.policyEndDate;
      const result = filter.filterTime(policyEndDate, 'YYYY-MM-DD');
      return <span>{result}</span>;
    }
  },
  {
    title: "最晚续保日",
    width: 110,
    align: "center",
    render(h, params) {
      const latestRenewalDate = params.row.latestRenewalDate;
      const result = filter.filterTime(latestRenewalDate, 'YYYY-MM-DD');
      return <span>{result}</span>;
    }
  },
  {
    title: "原单保费/续保保费（元）",
    width: 170,
    align: "center",
    render(h, params) {
      return <span>{params.row.fee} / {params.row.payFee?params.row.payFee:'-'}</span>;
    }
  },
  {
    title: "服务费（元）",
    width: 120,
    key: "commissionPrice",
    align: "center",
  },
  {
    title: "机构/业务员",
    align: "center",
    minWidth: 200,
    render(h, params) {
      return <span>{params.row.orgName}/{params.row.salesmanName}</span>;
    }
  },
  {
    title: "操作",
    slot: "bar",
    align: "center",
    width: 80,
    fixed: "right",
  },
]


// 待续保
export const renewalProtectColumns = [
  {
    title: "原保单号",
    width: 250,
    slot: "policyNo",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "保单到期日",
    width: 130,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      const policyEndDate = params.row.policyEndDate;
      const result = filter.filterTime(policyEndDate, 'YYYY-MM-DD');
      return <span>{result}</span>;
    }
  },
  {
    title: "最晚续保日",
    width: 270,
    align: "center",
    ellipsis: true,
    tooltip: true,
    slot:'slotColumn',
  },
  {
    title: "产品名称",
    key: "productName",
    align: "center",
    width: 250,
  },
  {
    title: "投保人/手机号",
    width: 160,
    align: "center",
    render(h, params) {
      return <span>{params.row.holderName}/{params.row.holderMobile}</span>;
    }
  },
  {
    title: "原单状态",
    key: "status",
    align: "center",
    minWidth: 100,
    render(h, params) {
      const payStatus = params.row.policyStatus;
      const result = filter.filterInsureOrderStatus(payStatus);
      return <span>{result}</span>;
    },
  },
  {
    title: "更进状态",
    width: 100,
    align: "center",
    render(h, params) {
      const serviceState = params.row.serviceState;
      if (serviceState == 1) {
        return <span>待跟进</span>;
      } else if (serviceState == 2) {
        return <span>跟进中</span>;
      } else if (serviceState == 3) {
        return <span>跟进完成</span>;
      }

    },
  },
  {
    title: "原单保费（元）",
    width: 140,
    key: "fee",
    align: "center",
  },
  {
    title: "机构/业务员",
    align: "center",
    minWidth: 200,
    render(h, params) {
      return <span>{params.row.orgName}/{params.row.salesmanName}</span>;
    }
  },
  {
    title: "操作",
    slot: "bar",
    align: "center",
    width: 180,
    fixed: "right",
  }
]


// 已续保
export const renewedColumns = [
  {
    title: "原保单号",
    slot: "policyNo",
    align: "center",
    width: 220,
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "续保保单号",
    key: "newPolicyNo",
    align: "center",
    width: 220,
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "投保人/手机号",
    width: 160,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.holderName}/{params.row.holderMobile}</span>;
    }
  },
  {
    title: "原单状态",
    align: "center",
    minWidth: 100,
    tooltip: true,
    render(h, params) {
      const payStatus = params.row.policyStatus;
      const result = filter.filterInsureOrderStatus(payStatus);
      return <span>{result}</span>;
    },
  },
  {
    title: "保单到期日",
    width: 110,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      const policyEndDate = params.row.policyEndDate;
      const result = filter.filterTime(policyEndDate, 'YYYY-MM-DD');
      return <span>{result}</span>;
    }
  },
  {
    title: "原单保费/续保保费（元）",
    width: 170,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.fee} / {params.row.payFee?params.row.payFee:'-'}</span>;
    }
  },
  {
    title: "服务费（元）",
    width: 120,
    key: "commissionPrice",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "续保来源",
    width: 100,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      if (params.row.renewalSource == 1) {
        return <span>原单续保</span>;
      } else if (params.row.renewalSource == 2) {
        return <span>转新单</span>;
      } else if (params.row.renewalSource == 3) {
        return <span>重投</span>;
      } else if (params.row.renewalSource == 4) {
        return <span>转新产品</span>;
      }else{
        return <span>-</span>;
      }
    }
  },
  {
    title: "机构/业务员",
    align: "center",
    minWidth: 200,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.orgName}/{params.row.salesmanName}</span>;
    }
  },
  {
    title: "操作",
    slot: "bar",
    align: "center",
    width: 180,
    fixed: "right",
  }
]


// 续保失败，已过宽限期
export const otherColumns = [
  {
    title: "原保单号",
    slot: "policyNo",
    align: "center",
    width: 220,
  },
  {
    title: "产品名称",
    width: 250,
    key: "productName",
    align: "center",
  },
  {
    title: "投保人/手机号",
    width: 160,
    align: "center",
    render(h, params) {
      return <span>{params.row.holderName}/{params.row.holderMobile}</span>;
    }
  },
  {
    title: "原单状态",
    align: "center",
    minWidth: 100,
    render(h, params) {
      const payStatus = params.row.policyStatus;
      const result = filter.filterInsureOrderStatus(payStatus);
      return <span>{result}</span>;
    },
  },
  {
    title: "保单到期日",
    width: 110,
    align: "center",
    render(h, params) {
      const policyEndDate = params.row.policyEndDate;
      const result = filter.filterTime(policyEndDate, 'YYYY-MM-DD');
      return <span>{result}</span>;
    }
  },
  {
    title: "最晚续保日",
    width: 270,
    align: "center",
    slot:'slotColumn',
  },
  {
    title: "原单保费（元）",
    width: 120,
    key: "fee",
    align: "center",
  },
  {
    title: "失败原因",
    width: 140,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.payFailTypeDesc?params.row.payFailTypeDesc:'-'}</span>;
    },
  },
  {
    title: "机构/业务员",
    align: "center",
    minWidth: 200,
    render(h, params) {
      return <span>{params.row.orgName}/{params.row.salesmanName}</span>;
    }
  },
  {
    title: "操作",
    slot: "bar",
    align: "center",
    width: 180,
    fixed: "right",
  }
]

// 不可续保
export const columns5 = [
  {
    title: "原保单号",
    slot: "policyNo",
    align: "center",
    width: 220,
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "产品名称",
    width: 250,
    key: "productName",
    align: "center",
  },
  {
    title: "投保人/手机号",
    width: 160,
    align: "center",
    ellipsis: true,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.holderName}/{params.row.holderMobile}</span>;
    }
  },
  {
    title: "原单状态",
    align: "center",
    minWidth: 100,
    tooltip: true,
    render(h, params) {
      const payStatus = params.row.policyStatus;
      const result = filter.filterInsureOrderStatus(payStatus);
      return <span>{result}</span>;
    },
  },
  {
    title: "保单到期日",
    width: 270,
    align: "center",
    ellipsis: true,
    tooltip: true,
    slot:'slotColumn',
  },
  {
    title: "原单保费（元）",
    width: 120,
    key: "fee",
    align: "center",
    ellipsis: true,
    tooltip: true,
  },
  {
    title: "机构/业务员",
    align: "center",
    minWidth: 200,
    tooltip: true,
    render(h, params) {
      return <span>{params.row.orgName}/{params.row.salesmanName}</span>;
    }
  },
  {
    title: "操作",
    slot: "bar",
    align: "center",
    width: 180,
    fixed: "right",
  }
]